<template>
  <div class="page-content" style="padding: 15px" v-loading="loading.join">
    <div v-if="!meeting_data.id" class="px-3">
      <b-card class="overflow-hidden text-center" style="max-width: 100%">
        <b-row no-gutters>
          <b-col md="12">
            <b-card-body class="pr-5">
              <h3 class="my-2 text-primary">Meeting Schedule Not Found</h3>
              <b-card-text>
                Pastikan Anda memasukkan kode rapat yang benar di URL dan pastikan jadwal meeting belum terlewat.
              </b-card-text>
              <!-- <el-button v-if="activeUser.id" class="mt-5" type="primary" @click="back" :loading="loading.join">
                Back to Dashboard
              </el-button> -->
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div v-else-if="userProfile.joined === false">
      <b-card class="overflow-hidden before-join text-white" style="max-width: 100%">
        <b-row no-gutters>
          <b-col md="4">
            <b-card-body class="pr-5">
              <h3 class="my-2 text-primary">Join Meeting</h3>
              <b-card-text>
                This is a wider card with supporting text as a natural lead-in to additional content.
                This content is a little bit longer.
              </b-card-text>
              <h4 class="mt-4">{{ meeting_data.name }}</h4>
              <b-card-text class="mb-3">{{ meeting_data.description }}</b-card-text>
              <h5 v-if="participantFull" class="mt-2 text-danger">Please reach out to the agent if you are interested in joining, as the current participant spots are full.<br>The agent can provide information on any availability or next steps.</h5>
              <div v-else-if="jitsiConnect">
                <el-form>
                  <b-card-text class="mb-1">Join as Guest</b-card-text>
                  <el-input size="small" placeholder="Enter User Name" v-model="userProfile.name"></el-input>
                  <el-button size="small" class="mt-3" type="primary" v-if="!room" @click="initJoin" :loading="loading.join">
                    Join Meeting
                  </el-button>
                </el-form>
                <div class="d-flex mt-3">
                  <el-button circle size="small" type="info" @click="toggleMic">
                    <FeatherIcon :type="userProfile.audioMuted ? 'mic-off' : 'mic'" size="12px" />
                  </el-button>
                  <el-button size="small" type="info" @click="toggleCam" circle>
                    <FeatherIcon :type="userProfile.videoMuted ? 'video-off' : 'video'" size="12px" />
                  </el-button>
                </div>
              </div>
            </b-card-body>
          </b-col>
          <b-col md="8">
            <div class="video-focus h-100 w-100">
              <video id="focusedVideoBefore" ref="focusedVideoBefore" autoplay></video>
              <div class="participant-label">
                <font-awesome v-if="userProfile.audioMuted" icon="volume-mute"/>
                {{ userProfile.name }}
              </div>
              <div v-if="userProfile.videoMuted" class="muted-video">
                <img class="rounded-circle" :src="userAvatar(userProfile.name)" alt="profile">
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div v-else-if="this.userProfile.joined === true && room">
      <b-card class="after-join">
        <b-row>
          <b-col md="10">
            <div class="video-focus h-85 w-100">
              <video id="focusedVideo" ref="focusedVideo" autoplay playsinline></video>
              <div class="participant-label">
                <font-awesome v-if="focusedParticipant.audioMuted" icon="volume-mute"/>
                {{ focusedParticipant.name }}
              </div>
              <div v-if="focusedParticipant.videoMuted" class="muted-video">
                <img class="rounded-circle" :src="userAvatar(focusedParticipant.name)" alt="profile">
              </div>
            </div>
            <div class="d-flex justify-content-center m-3">
              <el-button circle size="small" :type="grid ? 'primary' : 'info'" @click="toggleFocus">
                <FeatherIcon :type="grid ? 'grid' : 'monitor'" size="15px" class="m-1" />
              </el-button>
              <el-button circle size="small" type="info" @click="toggleMic">
                <FeatherIcon :type="userProfile.audioMuted ? 'mic-off' : 'mic'" size="15px" class="m-1" />
              </el-button>
              <el-button v-if="this.focusedParticipant.id !== 'sharing'" circle size="small" type="warning" @click="startSharing">
                <FeatherIcon type="share" size="15px" class="m-1" />
              </el-button>
              <el-button v-else-if="this.focusedParticipant.id == 'sharing'" circle size="small" type="danger" @click="stopSharing">
                <FeatherIcon type="square" size="15px" class="m-1" />
              </el-button>
              <el-button size="small" type="info" @click="toggleCam" circle>
                <FeatherIcon :type="userProfile.videoMuted ? 'video-off' : 'video'" size="15px" class="m-1" />
              </el-button>
              <el-button circle size="small" type="danger" @click="endCall">
                <FeatherIcon type="log-out" size="15px" class="m-1" />
              </el-button>
            </div>
          </b-col>
          <b-col md="2" class="px-2 overflow-auto" style="max-height: 570px">
            <div class="video-sidebar mb-3">
              <div
                v-for="(participant) in participants" :key="participant.id"
                class="video-thumbnail w-100"
                @click="setFocus($event, participant.id)"
              >
                <video class="video-preview" :id="`participant_video_container_${participant.connectionJid}`" :ref="`participantVideo_${participant.connectionJid}`" autoplay playsinline></video>
                <div class="participant-label">
                  <font-awesome v-if="participant.audioMuted" icon="volume-mute"/>
                  {{ participant.name }}
                </div>
                <div v-if="participant.videoMuted" class="muted-video-mini">
                  <img class="rounded-circle" :src="userAvatar(participant.name)" style="width: 50%; height: 50%">
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div v-else>
      <div class="meeting-container">
        <div v-if="!grid" class="row w-50">
          <div :class="participants.length > 1 ? 'col-10' : 'col-12'">
            <div>
              <!-- Main Video Section -->
              <div class="video-focus h-100 w-100">
                <video id="focusedVideo" ref="focusedVideo" autoplay playsinline></video>
                <div class="participant-label">
                  <font-awesome v-if="focusedParticipant.audioMuted" icon="volume-mute"/>
                  {{ focusedParticipant.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="overflow-auto" :class="listParticipants.length > 1 ? 'col-2' : 'hidden'">
            <!-- Sidebar with Participant Thumbnails -->
            <div class="video-sidebar">
              <!-- <div class="video-thumbnail w-100" @click="setFocus('me')">
                <video ref="localVideo" autoplay playsinline></video>
                <div class="participant-label">
                  <font-awesome v-if="!audioMuted" icon="volume-mute"/>
                  You
                </div>
              </div> -->
              <div
                v-for="(participant, id) in listParticipants()" :key="id"
                class="video-thumbnail w-100"
                @click="setFocus(participant.id)"
              >
                <video :id="`participant_video_container_${participant.id}`" :ref="`participantVideo_${participant.id}`" autoplay playsinline></video>
                <!-- <div class="avatar-container text-center">
                  <el-avatar class="align-middle" :src="'https://api.dicebear.com/9.x/initials/svg?seed=' + remoteStreamIds[participant.id].name"/>
                </div> -->
                <div class="participant-label">
                  <font-awesome v-if="participant.audioMuted" icon="volume-mute"/>
                  {{ participant.name }}
                  <!-- {{ remoteStreamIds[participant.id].name }} -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="grid" class="row h-100 w-100">
          <div class="overflow-auto" :class="thumbnailStyle">
            <!-- Sidebar with Participant Thumbnails -->
            <div class="video-sidebar">
              <div
                thumbnail
                v-for="(participant, id) in participants" :key="id"
                class="video-thumbnail-grid h-100 w-100"
                @click="setFocus(participant.id)"
              >
                <video :id="`participant_video_container_${participant.id}`" autoplay playsinline></video>
                <!-- <div class="avatar-container text-center">
                  <el-avatar class="align-middle" :src="'https://api.dicebear.com/9.x/initials/svg?seed=' + remoteStreamIds[participant.id].name"/>
                </div> -->
                <div class="participant-label">
                  <font-awesome v-if="participant.audioMuted" icon="volume-mute"/>
                  {{ participant.name }}
                  <!-- {{ remoteStreamIds[participant.id].name }} -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <el-button circle size="small" :type="grid ? 'primary' : 'info'" @click="toggleFocus">
            <FeatherIcon :type="grid ? 'grid' : 'monitor'" size="15px" class="m-1" />
          </el-button>
          <el-button circle size="small" type="info" @click="toggleMic">
            <FeatherIcon :type="audioMuted ? 'mic' : 'mic-off'" size="15px" class="m-1" />
          </el-button>
          <el-button v-if="this.focusedParticipant.id !== 'sharing'" circle size="small" type="warning" @click="startSharing">
            <FeatherIcon type="share" size="15px" class="m-1" />
          </el-button>
          <el-button v-else-if="this.focusedParticipant.id == 'sharing'" circle size="small" type="danger" @click="stopSharing">
            <FeatherIcon type="square" size="15px" class="m-1" />
          </el-button>
          <el-button size="small" type="info" @click="toggleCam" circle>
            <FeatherIcon :type="videoMuted ? 'video' : 'video-off'" size="15px" class="m-1" />
          </el-button>
          <el-button circle size="small" type="danger" @click="endCall">
            <FeatherIcon type="log-out" size="15px" class="m-1" />
          </el-button>
        </div>
      </div>
    </div>
    <audio class="hidden" id="audio" ref="audio" autoplay controls></audio>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import moment from 'moment';
import avatar from '@/library/avatar';
import videoCall from '../../../api/videoCallParticipant';

export default {
  data() {
    return {
      focusedParticipant: {},
      participants: [],
      connection: null,
      room: null,
      localTrack: null,
      localAudioTrack: null,
      localVideoTrack: null,
      // remoteStreams: [{
      //   name: 'Jasson',
      //   id: 'test',
      // }],
      grid: false, // grid = true, focus = false
      userProfile: {
        id: '',
        name: '',
        avatar: '',
        background: '',
        role: '',
        joined: false,
        audioMuted: false,
        videoMuted: false,
        me: {},
      },
      remoteStreams: null,
      remoteStreamIds: {},
      // remoteStreamIds: {
      //   test: {
      //     name: 'Jasson',
      //   },
      // },
      isMuted: false,
      roomName: '',
      isHost: false,
      token: null,
      // token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJqaXRzaSIsImlzcyI6InlvdXItYXBwIiwic3ViIjoibWVldC55b3VyZG9tYWluLmNvbSIsInJvb20iOiJNeUN1c3RvbVJvb20iLCJleHAiOjE3NDAwNTI0MjQsImNvbnRleHQiOnsidXNlciI6eyJhdmF0YXIiOiJodHRwczovL3lvdXJkb21haW4uY29tL2F2YXRhci5wbmciLCJuYW1lIjoiSG9zdCBVc2VyIiwiZW1haWwiOiJob3N0QGV4YW1wbGUuY29tIiwibW9kZXJhdG9yIjp0cnVlfX0sImlhdCI6MTc0MDA0ODgyNH0.z9D658cso7pfrmEvuJp3pBplFFi2rgmRmkKPxaZnbWI',
      // participantVideos: {},
      loading: {
        join: false,
      },
      meeting_data: {},
      participantFull: false,
      jitsiConnect: false,
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
    activeUser() {
      return this.$store.state.auth.userProfile;
    },
    thumbnailStyle() {
      let style = 'col-lg-2 col-sm-2';
      if (this.participants.length <= 4) {
        style = 'col-lg-6 col-sm-6';
      } else if (this.participants.length <= 12) {
        style = 'col-lg-4 col-sm-4';
      } else if (this.participants.length <= 16) {
        style = 'col-lg-3 col-sm-3';
      }
      return style;
    },
  },
  methods: {
    userAvatar(name) {
      return avatar(name);
    },
    listParticipants() {
      if (this.participants.length > 0) {
        console.log(this.participants.filter((v) => v.status === 'join'));
        return this.participants.filter((v) => v.status === 'join');
      }
      return [];
    },
    toggleFocus() {
      this.grid = !this.grid;
    },
    getDetail() {
      // this.$loading.show();
      videoCall.detail(
        this.$route.params.meeting_id,
      ).then(async (res) => {
        // this.$loading.hide();
        if (res.data && res.data.id) {
          this.meeting_data = res.data;
          this.roomName = res.data.room_id.toLowerCase();
          await JitsiMeetJS.init();
          this.$nextTick(async () => {
            await this.initJitsi();
            await this.createLocalTrack('focusedVideoBefore');
          });
        }
      }).catch((err) => {
        console.log(err);
        // this.$loading.hide();
      });
    },
    async createLocalTrack(focusId) {
      // Create local video/audio stream
      // { 1: localStream }
      JitsiMeetJS.createLocalTracks({
        devices: ['audio', 'video'],
        mirror: true,
        // resolution: 1080,
        // cameraDeviceId: '',
        // micDeviceId: '',
        // desktopSharingSourceDevice: '',
      }).then((localStream) => {
        this.localTrack = localStream;
        this.localVideoTrack = localStream.find((v) => v.type === 'video');
        this.localAudioTrack = localStream.find((v) => v.type === 'audio');
        const cameraMe = document.getElementById(focusId);
        // cameraMe.style.transform = 'rotateY(180deg)';
        // cameraMe.style.msTransform = 'rotateY(180deg)';
        this.localVideoTrack.attach(cameraMe);
        // this.localVideoTrack = localStream.find((v) => v.type === 'video');
        // this.localAudioTrack = localStream.find((v) => v.type === 'audio');
        // Attach track to a video element
        // this.$refs.focusedVideoBefore.srcObject = new MediaStream([this.localVideoTrack.getTrack()]);
      });
    },
    async initJitsi() {
      // const domain = 'meet.makna.ai';
      // const domain = this.meeting_data.domain;
      this.jitsiConnect = false;
      const options = {
        hosts: {
          domain: this.meeting_data.domain,
          muc: `conference.${this.meeting_data.domain}`,
          anonymousdomain: `guest.${this.meeting_data.domain}`,
        },
        serviceUrl: `https://${this.meeting_data.domain}/http-bind`,
        websocket: `wss://${this.meeting_data.domain}/xmpp-websocket`,
        clientNode: 'custom-client',
      };

      // Initialize connection
      this.connection = new JitsiMeetJS.JitsiConnection(null, this.token, options);
      console.log('this.token', this.token);
      console.log('connection', this.connection);

      this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED, this.onConnected);
      this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_FAILED, this.onFailed);
      this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED, this.onDisconnected); // disconnect
      await this.connection.connect();
    },
    onFailed() {
      this.loading.join = false;
      this.jitsiConnect = false;
      this.$message({
        type: 'error',
        message: 'Failed joined to the room. Connection failed',
      });
    },
    onDisconnected() {
      this.loading.join = false;
      this.jitsiConnect = false;
      this.$message({
        type: 'error',
        message: 'Failed joined to the room. Disconnected',
      });
    },
    onConnected() {
      this.loading.join = false;
      this.jitsiConnect = true;
      console.log('Connected. Ready to join the room');
    },
    initJoin() {
      console.log('this.roomName', this.roomName);
      this.loading.join = true;
      this.room = this.connection.initJitsiConference(this.roomName, {});
      // this.room = this.connection.initJitsiConference('testroom', {});
      const myId = this.room.myUserId();
      videoCall.join({
        meeting_id: this.$route.params.meeting_id,
        data: {
          username: this.userProfile.name,
          participant_id: myId,
        },
      }).then((res) => {
        if (res.data) {
          this.userProfile.me = res.data.me;
          this.room.on(JitsiMeetJS.events.conference.CONFERENCE_JOINED, this.onJoined);
          this.room.on(JitsiMeetJS.events.conference.TRACK_ADDED, this.onRemoteTrack);
          this.room.on(JitsiMeetJS.events.conference.TRACK_REMOVED, this.onRemoveTrack);
          this.room.on(JitsiMeetJS.events.conference.USER_JOINED, this.onUserJoined);
          this.room.on(JitsiMeetJS.events.conference.PARTICIPANT_PROPERTY_CHANGED, this.onGetParticipant);
          this.room.on(JitsiMeetJS.events.conference.TRACK_MUTE_CHANGED, this.onMuteTrack);
          this.room.on(JitsiMeetJS.events.conference.USER_LEFT, this.onUserLeft);
          const obj = {
            id: res.data.me.id,
            connectionJid: myId,
            videoRef: `participantVideo_${res.data.me.id}`,
            audioMuted: this.userProfile.audioMuted,
            videoMuted: this.userProfile.videoMuted,
            joined_at: moment(res.data.me.joined_at).format('YYYY-MM-DD HH:mm:ss'),
            name: res.data.me.username,
            role: res.data.me.role,
            status: 'join',
          };
          this.focusedParticipant = obj;
          this.room.join();
          this.room.setDisplayName(this.userProfile.name);
          this.participants.push(obj);
          this.userProfile.joined = true;
          this.loading.join = false;
          this.$message({
            type: 'success',
            message: 'Joined to the room',
          });
          this.remoteStreams = new MediaStream();
          this.$nextTick(() => {
            this.room.addTrack(this.localAudioTrack);
            this.room.addTrack(this.localVideoTrack);
            // this.localVideoTrack = this.localTrack.find((v) => v.type === 'video');
            // this.localAudioTrack = this.localTrack.find((v) => v.type === 'audio');
            // const focusVideoBefore = document.getElementById('focusedVideoBefore');
            // focusVideoBefore.pause();
            // const localTrack = this.room.getLocalTracks();
            // console.log('localTrack', localTrack);
            const focusVideo = document.getElementById('focusedVideo');
            // focusVideo.style.transform = 'rotateY(180deg)';
            // focusVideo.style.msTransform = 'rotateY(180deg)';
            this.localVideoTrack.attach(focusVideo);
            const sidebarVideo = document.getElementById(`participant_video_container_${obj.connectionJid}`);
            this.localVideoTrack.attach(sidebarVideo);
          });
          // this.createLocalTrack('focusedVideo');
          // if (res.data.participants.length > 1) {
          //   this.grid = true;
          // } else {
          //   this.grid = false;
          //   this.focusedParticipant = res.data.me;
          //   this.focusedParticipant.audioMuted = this.userProfile.audioMuted;
          //   this.focusedParticipant.videoMuted = this.userProfile.videoMuted;
          // }
          // start save connected join - user join save
          // end save
          this.loading.join = false;
        } else {
          this.loading.join = false;
        }
      }).catch((err) => {
        console.log(err);
        this.loading.join = false;
      });
    },
    onJoined() {
      const participant_in_room = this.room.getParticipants().length;
      if (participant_in_room >= parseInt(this.meeting_data.participant)) {
        this.endCall('full');
      } else {
        this.room.setLocalParticipantProperty('data', JSON.stringify(this.focusedParticipant));
      }
    },
    setFocus(event, id) {
      if (!event.target.classList.contains('controls')) {
        return;
      }
      const get_participant = this.participants.find((v) => v.id === id);
      if (get_participant) {
        this.focusedParticipant = get_participant;
        // if (track.type === 'video') {
        // const videoElement = document.getElementById(`participant_video_container_${id}`);
        const videoElement = document.getElementById(`participant_video_container_${get_participant.connectionJid}`);
        if (videoElement) {
          this.$refs.focusedVideo.srcObject = videoElement.srcObject;
        }
        // }
      }
    },
    onUserJoined(id, JitsiParticipant) {
      if (this.userProfile.me.participant_id === id) return;
      console.log('onUserJoined', id, JitsiParticipant);
      const obj = {
        id,
        connectionJid: id,
        videoRef: `participantVideo_${id}`,
        audioMuted: false,
        videoMuted: false,
        name: JitsiParticipant._displayName,
        role: 'participant',
        status: 'join',
      };
      this.participants.push(obj);
      // onKickParticipant(participant)
    },
    onGetParticipant(participant, key, oldValue, newValue) {
      if (key === 'data') {
        const idx = this.participants.findIndex((v) => v.connectionJid === participant.connectionJid);
        const data = JSON.parse(newValue);
        this.participants[idx] = data;
      }
    },
    onKickParticipant(participant) {
      const participantId = participant.getId();
      this.room.kickParticipant(participantId);
    },
    onRemoteTrack(track) {
      if (track.isLocal()) return;
      const participantId = track.getParticipantId();
      console.log('new remote stream', participantId, track);
      // if (this.participants.length > 1 && !this.grid) {
      //   this.grid = true;
      // }
      if (track.type === 'video') {
        const videoElement = document.getElementById(`participant_video_container_${participantId}`);
        track.attach(videoElement);
        const obj = this.participants.find((v) => v.connectionJid === participantId);
        // this.participantVideos[participantId] = obj;
        this.$refs[`participantVideo_${participantId}`].srcObject = new MediaStream([track.getTrack()]);
        if (!this.focusedParticipant.id) {
          this.$refs.focusedVideo.srcObject = new MediaStream([track.getTrack()]);
          this.focusedParticipant = obj;
        }
        // this.remoteStreams.addTrack(track.getTrack());
      }
      if (track.type === 'audio') {
        console.log(track.getTrack());
        const audio = document.querySelector('audio#audio');
        const set_stream = new MediaStream([track.getTrack()]);
        // set_stream.attach(audio);
        audio.srcObject = set_stream;
        // set_stream.streams[0].getTracks().forEach((track) => {
        //   if (track) {
        //     this.remoteStream.addTrack(track); // Add each track to the remote stream
        //   }
        // });
        // audio.srcObject = set_stream;
        // this.remoteStreams.addTrack(track.getTrack());
        // set_stream.getTracks().forEach((tr) => {
        //   if (tr) {
        //     this.remoteStream.addTrack(tr); // Add each track to the remote stream
        //   }
        // });
      }
    },
    onUserLeft(id, JitsiParticipant) {
      console.log('onUserLeft', id, JitsiParticipant);
      const idx = this.participants.findIndex((v) => v.connectionJid === id);
      console.log('user left', idx);
      this.participants.splice(idx, 1);
      document.getElementById(`participant_video_container_${id}`).remove();
    },
    onRemoveTrack(track) {
      console.log('remove track', track);
      const obj = this.participants.find((v) => v.connectionJid === track.ownerEndpointId);
      if (obj > -1) {
        if (track.type === 'video') {
          const videoElement = document.getElementById(`participant_video_container_${v.connectionJid}`);
          track.attach(videoElement);
          this.$refs[`participantVideo_${obj.connectionJid}`].srcObject = new MediaStream([track.getTrack()]);
          if (this.focusedParticipant.id === obj.id) {
            this.$refs.focusedVideo.srcObject = new MediaStream([track.getTrack()]);
            this.focusedParticipant = obj;
          }
        }
        if (track.type === 'audio') {
          const audio = document.querySelector('audio#audio');
          const set_stream = new MediaStream([track.getTrack()]);
          audio.srcObject = set_stream;
        }
      }
      //   if (track.isLocal()) return;
      //   const participantId = track.getParticipantId();
      //   console.log('remove exist stream', participantId, track);

      //   console.log('stream after remove');
      //   console.log(this.remoteStreams.getTracks());
      //   this.$nextTick(() => {
      //     if (track.type === 'video') {
      //       document.getElementById(`participant_video_container_${participantId}`).remove();
      //     }
      //   });
    },
    async endCall(reason = null) {
      let end = null;
      if (this.userProfile.me.role === 'moderator') {
        end = await videoCall.end(this.activeWorkspace._id, this.$route.params.meeting_id);
        if (end) {
          this.room.end();
        }
      } else {
        end = await videoCall.leave(this.$route.params.meeting_id, this.userProfile.me.participant_id);
        if (end) {
          this.room.leave();
        }
      }
      if (end) {
        this.connection.disconnect();
        this.remoteStreams = null;
        this.participants = [];
        this.room = null;
        this.focusedParticipant = {};
        if (reason === 'full') {
          this.userProfile.joined = false;
          this.participantFull = true;
        }
      }
    },
    toggleMic() {
      this.userProfile.audioMuted = !this.userProfile.audioMuted;
      // this.localAudioTrack.getAudioTracks().forEach((track) => {
      //   track.enabled = !this.userProfile.audioMuted;
      // });
      if (this.userProfile.me.id) {
        console.log(this.userProfile.me.id);
        if (this.focusedParticipant.id === this.userProfile.me.id) {
          this.focusedParticipant.audioMuted = this.userProfile.audioMuted;
        }
        const idx = this.participants.findIndex((v) => v.id === this.userProfile.me.id);
        this.participants[idx].audioMuted = this.userProfile.audioMuted;
      }
      if (this.userProfile.audioMuted) {
        this.localAudioTrack.mute();
      } else {
        this.localAudioTrack.unmute();
      }
      // if (!this.userProfile.audioMuted) this.localAudioTrack.mute();
      // else {
      //   this.localAudioTrack.unmute();
      // }
    },
    toggleCam() {
      const focusId = this.userProfile.join ? 'focusedVideo' : 'focusedVideoBefore';
      this.userProfile.videoMuted = !this.userProfile.videoMuted;
      if (this.userProfile.me.id) {
        if (this.focusedParticipant.id === this.userProfile.me.id) {
          this.focusedParticipant.videoMuted = this.userProfile.videoMuted;
        }
        const idx = this.participants.findIndex((v) => v.id === this.userProfile.me.id);
        this.participants[idx].videoMuted = this.userProfile.videoMuted;
      }
      if (this.userProfile.videoMuted) {
        this.localVideoTrack.mute();
      } else {
        this.localVideoTrack.unmute();
        const focusVideo = document.getElementById(focusId);
        const sidebarVideo = document.getElementById(`participant_video_container_${this.userProfile.me.id}`);
        focusVideo.play();
        sidebarVideo.play();
        // this.$refs.focusedVideo.srcObject = new MediaStream([this.localVideoTrack.getTrack()]);
      }
    },
    onMuteTrack(track) {
      // if (track.isLocal()) {
      //   if (!track.muted) this.$refs.localVideo.srcObject = new MediaStream([track.getTrack()]);
      //   return;
      // }
      const participantId = track.getParticipantId();
      const idx = this.participants.findIndex((v) => v.connectionJid === participantId);
      if (idx >= 0) {
        if (track.type === 'audio') {
          this.participants[idx].audioMuted = track.muted;
        } else if (track.type === 'video') {
          this.participants[idx].videoMuted = track.muted;
        }
      }
      console.log('Muted track', participantId, track);
      // if (this.remoteStreamIds[participantId][`${track.type}Muted`] !== undefined) {
      //   this.remoteStreamIds[participantId][`${track.type}Muted`] = track.muted;
      // }
    },
    async startSharing() {
      const stream = await navigator.mediaDevices.getDisplayMedia();
      const videoTrack = stream.getVideoTracks()[0];
      // const audioTrack = stream.getAudioTracks()[0];
      this.focusedParticipant = {
        id: 'screen-share',
        connectionJid: 'screen-share-video',
        videoRef: 'participantVideo_screen-share',
        audioMuted: false,
        videoMuted: false,
        joined_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        name: 'Screen Sharing',
        role: 'screen',
        status: 'join',
      };
      this.participants.push(this.focusedParticipant);
      await JitsiMeetJS.createLocalTracks({
        devices: ['desktop'],
        desktopSharingSourceDevice: stream.id,
        // constraints: {
        //   video: { mediaSource: 'screen' }
        // }
      }).then((screenTracks) => {
        this.$refs.focusedVideo.srcObject = new MediaStream([videoTrack]);
        // this.$refs['participantVideo_screen-share'].srcObject = new MediaStream([videoTrack]);
        const screenShared = document.getElementById('participant_video_container_screen-share');
        videoTrack.attach(screenShared);
        // screenShared.srcObject = new MediaStream([videoTrack]);
        screenTracks.forEach((track) => {
          this.room.addTrack(track); // Add the screen share to the room
        });
        // const screenTrack = screenTracks[0];
        // this.localTrack.push(screenTrack);
        // this.room.addTrack(screenTrack);
      }).catch((err) => {
        console.log(err);
      });
      // this.room.addTrack(audioTrack);
      // await sharing(list.id);
    },
    stopSharing() {
      const screenTrack = this.localTrack.find((track) => (track.getType() === 'video' || track.getType() === 'desktop') && track.mediaSource === 'screen');
      if (screenTrack) {
        // Stop the track and remove it from the conference
        screenTrack.stop();
        this.room.removeTrack(screenTrack);
        this.localTrack = this.localTrack.filter((track) => track !== screenTrack);
      }
    },
  },
  mounted() {
    this.getDetail();
  },
};
</script>

<style scoped>
.before-join {
  background: #222;
  border-radius: 7px;
}

.after-join {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 600px;
  background: #222;
  border-radius: 7px;
}

.meeting-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background: #222;
  padding: 15px 5px 15px 5px;
  border-radius: 5px;
}
.video-preview {
  transform: none !important;
}

.video-focus {
  flex-grow: 1;
  width: 100%;
  height: auto;
  max-height: 100%;
  background: black;
  border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-focus video {
  /* width: 100%;
  height: 100%; */
  width: 100%;
  border-radius: 5px;
  /* height: auto; */
  object-fit: cover;
  height: 500px;
}

.video-sidebar {
  /* position: absolute; */
  /* right: 10px; */
  /* top: 10px; */
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.video-thumbnail {
  /* width: 120px; */
  /* height: 100%; */
  background: black;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
}
.video-thumbnail video {
  width: 100%;
  border-radius: 5px;
  height: 100px;
  object-fit: cover;
  max-height: 100px;
}

.video-thumbnail-grid {
  /* width: 120px; */
  /* height: 100%; */
  background: black;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
}
.video-thumbnail-grid video {
  width: 100%;
  border-radius: 5px;
  height: 100%;
  object-fit: cover;
  max-height: 300px;
}

.participant-label {
  position: absolute;
  bottom: 5px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 3px 8px;
  border-radius: 5px;
  font-size: 12px;
}

.controls {
  position: absolute;
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.muted-video {
  position: absolute;
}
.muted-video-mini {
  position: absolute;
  top: 40%;
  left: 40%;
}

.avatar-container {
  /* display: flex;
  align-items: center;
  justify-content: center;
  height: 100%; */
  /* margin-top: 50%; */
  text-align: center;
}

/* grid */
.row-grid {
  display: -ms-flexbox; /* IE10 */
  display: flex;
  -ms-flex-wrap: wrap; /* IE10 */
  flex-wrap: wrap;
  padding: 0 4px;
}

/* Create four equal columns that sits next to each other */
.column-grid {
  -ms-flex: 25%; /* IE10 */
  flex: 25%;
  max-width: 25%;
  padding: 0 4px;
}

.column-grid img {
  margin-top: 8px;
  vertical-align: middle;
  width: 100%;
}

/* Responsive layout - makes a two column-layout instead of four columns */
@media screen and (max-width: 800px) {
  .column-grid {
    -ms-flex: 50%;
    flex: 50%;
    max-width: 50%;
  }
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column-grid {
    -ms-flex: 100%;
    flex: 100%;
    max-width: 100%;
  }
}
</style>
